import * as React from 'react';

interface HandRaiseIconProps {
  isActive?: boolean;
  onClick?: () => void;
}
export function HandRaiseIcon({ isActive, onClick }: HandRaiseIconProps) {
  return (
    <div
      data-testid="hand-raise-icon"
      className="cursor-pointer"
      onClick={onClick}
    >
      {isActive ? (
        <svg
          width="24"
          height="24"
          viewBox="0 0 24 24"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="m22.526 8.971-4.646 7.082v7.061H2.729v-4.913a3 3 0 0 1 1.885-2.786l7.584-3.033c2.075-.83 4.23-4.307 5.303-6.249.454-.822 1.248-1.416 2.176-1.564 2.459-.393 4.215 2.32 2.85 4.402Z"
            className="fill-cyan-500"
          />
          <circle cx="8.5" cy="7.5" r="4.5" className="fill-cyan-500" />
        </svg>
      ) : (
        <svg
          width="24"
          height="24"
          viewBox="0 0 24 24"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
          className="cursor-pointer"
        >
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M2.712 18.62c0-1.54.94-2.924 2.374-3.49 2.014-.794 5.17-2.04 7.136-2.826.412-.165.88-.496 1.383-.973.496-.473.993-1.056 1.466-1.685.946-1.257 1.761-2.64 2.258-3.54a2.836 2.836 0 0 1 2.19-1.462c2.233-.223 3.77 2.186 2.63 4.117l-4.399 7.444v6.545h-1.5V16a.75.75 0 0 1 .104-.382l4.503-7.62a1.238 1.238 0 0 0-1.188-1.861c-.423.042-.809.3-1.027.695-.512.927-1.366 2.38-2.373 3.717a15.42 15.42 0 0 1-1.63 1.869c-.57.541-1.199 1.014-1.86 1.278-1.97.788-5.13 2.036-7.143 2.83a2.25 2.25 0 0 0-1.424 2.094v4.236h-1.5V18.62Z"
            className="fill-blue-900"
          />
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M8.5 10.5a3 3 0 1 0 0-6 3 3 0 0 0 0 6Zm0 1.5a4.5 4.5 0 1 0 0-9 4.5 4.5 0 0 0 0 9Z"
            className="fill-blue-900"
          />
        </svg>
      )}
    </div>
  );
}
